<template>
  <div class="home">
    <div class="soluBanner">
      <el-carousel
        class="bannder_s"
        indicator-position="none"
        :interval="5000"
        :height="imgHeight + 'px'"
      >
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
            <img :src="item.imgUrl" alt style="width: 100%" ref="image" />
          </a>
          <img v-else :src="item.imgUrl" alt style="width: 100%" ref="image" />
          <!--          <img :src="item" alt="" style="width: 100%" ref="image" />-->
          <el-button
            class="banner_video"
            v-if="item.videoUrl"
            @click="onClickVideo(item.videoUrl)"
          >查看视频</el-button>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 点击查看视频 -->
    <VideoDialog ref="videoDialogRef" />
    <!-- 新闻中心 -->
    <div class="new_center">
      <div class="title flex">
        <div class="title_left my-tabs">
          <span class="titleBig">NEWS</span>
          <!--          <span class="titleSmill">新闻资讯</span>-->
          <el-tabs v-model="activeName" @tab-click="handleClick" class="titleSmill">
            <el-tab-pane label="新闻资讯" name="first"></el-tab-pane>
            <el-tab-pane label="政策解读" name="second"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="new_center_top flex">
        <div class="new_center_top_left">
          <el-carousel height="300px" arrow="always" style="border-radius: 0 0 8px 8px;">
            <el-carousel-item v-for="(item, index) in newList" :key="index">
              <img
                style="width: 100%; height: 100%;object-fit:fill;border-radius: 0 0 8px 8px;"
                :src="item.pictureUrl"
                alt
                @click="getNewsItemDetail(item.uuid)"
              />
              <h3 class="small">{{ item.time }}</h3>
              <p class="new_left_title" @click="getNewsItemDetail(item.uuid)">
                <span>{{ item.title }}</span>
              </p>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="new_center_top_right" v-show="newCenterShow">
          <div
            class="new_right_box flex"
            v-for="(new_itmes, index) in newTopList"
            :key="index"
            @click="getNewsItemDetail(new_itmes.uuid)"
          >
            <div class="new_right_content">
              <div class="new_rightTime">
                <p class="new_right_time1">{{ moment(new_itmes.createDate).format("DD") }}</p>
                <p class="new_right_time">
                  {{ moment(new_itmes.createDate).format("MM") }}/{{
                  moment(new_itmes.createDate).format("YYYY")
                  }}
                </p>
              </div>
              <h4 class="new_right_title">{{ new_itmes.title }}</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="new_center_more" @click="getNewsMore">查看更多 ></div>
    </div>
    <!-- 数据 -->
    <AllMessage v-show="conShow" />
    <!-- 平台是核心 -->
    <div class="content">
      <div class="title flex">
        <div class="title_left">
          <span class="titleBig">SERVICE</span>
          <span class="titleSmill">平台服务</span>
        </div>
      </div>
      <div class="content_top1" v-show="conShow">
        <HomeSwiper :list="mainTabs" v-if="mainTabs.length" @tabsIndex="tabsIndexChange" />
      </div>
    </div>
    <!-- 商机线索 -->
    <BusinessLead v-if="mainTabs.length" v-show="conShow" class :msg="mainTabs[businessLeadIndex]" />
    <!-- 赋码追溯 -->
    <div :style="{ backgroundImage: `url(${codeBgUrl})`,backgroundSize: '100% 100%' }">
      <div class="coding">
        <div class="title flex">
          <div class="title_left">
            <span class="titleBig">TRACE</span>
            <span class="titleSmill">赋码追溯</span>
          </div>
        </div>
        <CodeTracing class="wow animate__animated animate__fadeIn" />
      </div>
      <!-- 生产数字化 -->
      <div class="proddDigitization">
        <div class="title flex">
          <div class="title_left">
            <span class="titleBig">DIGITALIZE</span>
            <span class="titleSmill">生产数字化</span>
          </div>
        </div>
        <DigitizationProd class="wow animate__animated animate__fadeIn" />
      </div>
    </div>
    <div class="park">
      <!-- 泵都风采 -->
      <div class="title flex">
        <div class="title_left">
          <span class="titleBig">CHARMING</span>
          <span class="titleSmill">泵都风采</span>
        </div>
      </div>
      <div class="park_box h-708">
        <div
          class="park_box"
          v-for="(imgItems, index) in parkInformationList"
          :key="index"
          v-show="parkIndex == index"
        >
          <div class="park_box_img">
            <img v-if="parkMess" :src="imgItems.thumbnail" alt />
          </div>
          <div class="park_background">
            <div class="park_box_mess" v-show="parkShow">
              <p class="park_box_messtitle">| {{ imgItems.parkName }}</p>
              <p
                class="park_box_messtext"
                @mouseenter="getMessagesAll"
                @mouseleave="getMessagesAllNo"
              >{{ imgItems.detail }}</p>
              <div class="flex bnt_box">
                <button
                  @click="goToParkVr(imgItems)"
                  class="flex"
                  v-if="imgItems.vrUrl ||
                  (imgItems.vrList && imgItems.vrList.length > 0)
                  "
                >
                  <img src="../assets/home/vr_icon.png" alt srcset />
                  <span>VR</span>
                </button>
                <span class="tpis" @click="goToParkDetail(imgItems.uuid)">详情 ></span>
              </div>
            </div>
          </div>
          <div class="park_imglist flex" v-show="parkShows">
            <div
              class="park_img"
              :class="indexs == parkIndex ? 'park_active' : 'park_img'"
              v-for="(imgItemss, indexs) in parkInformationList"
              :key="indexs"
              @click="getParkImg(indexs)"
            >
              <img :src="imgItemss.thumbnail" alt />
              <div class="title_box">{{ imgItemss.parkName }}</div>
              <div class="parkFuimg"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 产业集群 -->
      <div class="title flex" style="margin-top: 0;">
        <div class="title_left">
          <span class="titleBig">CLUSTER</span>
          <span class="titleSmill">产业集群</span>
        </div>
      </div>
      <div ref="quanping" class="park_bottom" :style="{ backgroundImage: `url(${companyImag})` }">
        <i v-show="!ifFullScreen" class="el-icon-full-screen iconStyle" @click="fullScreen('1')" />
        <i v-show="ifFullScreen" class="el-icon-aim iconStyle" @click="fullScreen('2')" />
        <div class="park_bottom_content my-select">
          <el-select
            v-model="city"
            placeholder="请选择"
            @change="changeCity($event)"
            clearable
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in regionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div class="flex pack_flex" v-show="packFlexShow">
            <parkEnterprise :fullScreenState="FullScreenState" :parkList="parkList" ref="mapRef"></parkEnterprise>
            <!-- <img :src="companyImag" alt="" class="pack_img"/> -->
            <!-- <div class="park_bottom_list" v-for="(items, index) in parkList" :key="index">
              <div class="park_bottom_img">
                <img :src="items.thumbnail" alt="" />
              </div>
              <div class="park_bottom_text">
                <div>{{ items.enterpriseName }}</div>
                <p class="gray" @mouseenter="getEnterpriseAll(items, index)" @mouseleave="getEnterpriseNo(items)">
                  {{ items.details }}
                </p>
              </div>
            </div>
            <div class="park_bottom_list2" v-for="item in 3" :key="item"></div>-->
          </div>
        </div>
      </div>
      <!--  -->
      <div class="hidden">
        <div class="title flex" style="margin-top: 10px">
          <div class="title_left">
            <span class="titleBig">CASE</span>
            <span class="titleSmill">赋能案例</span>
          </div>
        </div>
        <CaseCom v-if="solutionListQuery.length" :list="solutionListQuery" />
      </div>
    </div>
    <!-- 赋能案例 -->
    <!-- 平台优势 -->
    <div class="main">
      <div class="title flex">
        <div class="title_left">
          <span class="titleBig">ADVANTAGE</span>
          <span class="titleSmill">平台优势</span>
        </div>
      </div>
      <Advantage class="wow animate__animated animate__zoomIn" />
    </div>
  </div>
</template>

<script>
import screenfull from "screenfull";
import VideoDialog from "./VideoDialog/index";
import HomeSwiper from "./parkSwiper/homeSwiper";
import AllMessage from "./homeIndex/allMessage";
import BusinessLead from "./homeIndex/businessLead";
import CodeTracing from "./homeIndex/codeTracing.vue";
import DigitizationProd from "./homeIndex/digitizationProd.vue";
import CaseCom from "./homeIndex/caseCom.vue";
import Advantage from "./homeIndex/advantage.vue";
import parkEnterprise from "./homeIndex/parkEnterprise.vue";
import provinceData from "../utils/provinceData";

import { mapState, mapMutations } from "vuex";
import {
  getIndexParkList,
  queryNewText,
  getParkEnterpriseList,
  getParkAddrList,
  getBannerList,
  operationSystem,
  getPrintEnterPriseList,
  removeFollow,
  saveFollow,
  findShopSettledInfo,
  getNewcurrent,
  getIndexSolutionData,
  getSolutionList
} from "../utils/interface";

export default {
  name: "HelloWorld",
  metaInfo: {
    title: "水泵云— 水泵行业综合性工业互联网平台！", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "水泵 | 水泵云 | 盐湖水泵特色镇云平台| 泵业特色小镇 | 水泵智造行业平台 | 农业水泵解决方案| 工业互联网平台 | 水泵行业资讯| 盐湖区水泵 | 山西运城水泵之乡"
      },
      {
        // set meta
        name: "description",
        content:
          "水泵云是面向水泵行业的首个综合性工业互联网平台！依托盐湖区水泵特色专业镇产业优势，整合产业链资源，构建“1+6”生态服务体系，为行业用户提供产业协同、信息汇聚、人才培训、行业大数据、智能制造等信息化解决方案。"
      }
    ]
  },
  components: {
    HomeSwiper,
    AllMessage,
    BusinessLead,
    CodeTracing,
    DigitizationProd,
    CaseCom,
    Advantage,
    parkEnterprise,
    VideoDialog,
    provinceData
  },
  data() {
    return {
      isFullscreen: screenfull.isFullscreen,
      activeName: "first",
      codeBgUrl: require("@/assets/new/bg.png"),
      solutionImgs: require("../assets/solutionHome.png"),
      companyImag: require("../assets/home/company.png"),
      solutionListQuery: [],
      // 数据

      //轮播图
      bannerList: [],
      documenHeight: "",
      businessLeadIndex: 0,
      mapShow: false,
      // 新闻中心下面的列表信息
      newCenterShow: false,
      newCenterShow2: false,
      newList: [],
      newTopList: [],
      newItem: {},
      // 园区生态
      parkShow: false,
      parkShows: false,
      packFlexShow: false,
      parkIndex: 0,
      parkInformationList: [],
      parkImg: [],
      parkMess: {
        uuid: "",
        title: "",
        messages: ""
      },
      parkList: [],
      messageAll: false,
      enterpriseAll: false,
      enterpriseAllIndex: "0",
      // 解决方案
      soluShow: false,
      mapdata: [],
      solutionList: [],

      indexBanner: {
        imgUrl: "",
        url: "",
        name: "",
        uuid: ""
      },
      // 主要业务
      mainShow: false,
      mainTabs: [],
      mainTabsIn: "0",
      mainMess: {
        title: "",
        messages: "",
        value: ""
      },

      // 平台是核心
      contentTbas: "2",
      conShow: false,
      contentList: [],
      contentMess: {
        title: "平台是核心",
        messages:
          "平台是企业数字化转型的核心，是连接用户与设备、数据收集、分析、建模的载体，承载了构建丰富多彩的工业互联网应用生态的使命，是实现万物互联的核心"
      },
      contentIcon: [
        {
          icon: "icon"
        },
        {
          icon: "icon"
        },
        {
          icon: "icon"
        },
        {
          icon: "icon"
        },
        {
          icon: "icon"
        }
      ],
      // 地图
      ifbox: false,
      TipsList: [],
      inputMapParam: "",
      mapPopX: "0px",
      mapPopY: "0px",
      //地图对象数据
      mapParkDetail: {
        parkName: "",
        order: "",
        uuid: "",
        imageURL: "",
        capacity: "",
        peoNum: "",
        outPutValue: ""
      },
      setIn: null, // 定时器
      imgHeightsetIn: null,
      imgHeight: "",
      loading: true,
      // 服务商信息
      settledInfo: [],
      userMessages: {},
      regionOptions: provinceData,
      city: "",
      list: [
        {
          title: "设备",
          bgUrl: require("@/assets/new/bg1.png"),
          bgUrlExtend: require("@/assets/new/extend1.png"),
          text:
            "实现账料相符，供销匹配，降低库存堆积，提升盘点效率及资金利用效率；"
        },
        {
          title: "质量",
          bgUrl: require("@/assets/new/bg2.png"),
          bgUrlExtend: require("@/assets/new/extend2.png"),
          text:
            "生产过程数据实时查看，准确、快速统计绩效、产出和成本，减少人工统计时间；"
        },
        {
          title: "生产",
          bgUrl: require("@/assets/new/bg3.png"),
          bgUrlExtend: require("@/assets/new/extend3.png"),
          text:
            "生产数据统一、规范、标准的管理，减少信息处理错漏和缺失问题，形成结果和统计报表，方便效率；"
        },
        {
          title: "采购",
          bgUrl: require("@/assets/new/bg4.png"),
          bgUrlExtend: require("@/assets/new/extend4.png"),
          text:
            "通过RFID自动识别技术智能获取产品信息，实现对物品高效、准确、自动化追踪和管理。"
        }
      ],
      FullScreenState: false, // 是否变全屏
      initHeight: window.innerHeight, // 窗口非全屏状态下高度
      ifFullScreen: false // 是否是全屏
    };
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getIndexBanner();
        this.getIndexVocationalWork();
        // this.getMapData();
        this.getsolutionListApi();
        this.getParkInformationList();
        this.queryNewText();
        this.getBodyHeight();
        this.getProviderSettledInfo();
        this.getgetSolutionProList();
        //this.getParkEnterpriseList();
        // 获取用户信息
        getNewcurrent()
          .then(res => {
            this.userMessages = res;
          })
          .catch(err => {
            console.log(err);
          });
      }
    }, 500);
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.menu);
    // this.initEcharts();
    window.addEventListener("resize", () => {
      if (this.$refs.image[0]) {
        this.imgHeight = this.$refs.image[0].height;
      }
    });
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
      isLogin: "isLogin",
      isUsermessage: "isUsermessage"
    })
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;

      return y + "-" + MM + "-" + d;
    }
  },
  methods: {
    handleResize() {
      // 处理窗口大小变化的逻辑
      // 这里可以获取窗口的新宽度和高度
      const width = window.innerWidth;
      const height = window.innerHeight;
      // 通过窗口尺寸判断是不是全屏状态, true为全屏，false为非全屏
      this.ifFullScreen = this.initHeight < height;
    },
    ...mapMutations(["isLoginVuex"]),
    imgLoad() {
      this.$nextTick(function() {
        // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
        // this.imgHeight = (document.body.clientWidth * 1) / 4;
        this.imgHeightsetIn = setInterval(() => {
          if (this.imgHeight == 0) {
            if (this.$refs.image[0]) {
              this.imgHeight = this.$refs.image[0].height;
            }
          } else {
            clearInterval(this.imgHeightsetIn);
            // console.log(6666, this.imgHeight);
          }
        }, 520);
      });
    },
    /* 是否变全屏 */
    fullScreen(FullScreenState) {
      // FullScreenState 1-全屏 2-退出全屏
      this.FullScreenState = FullScreenState == "1" ? true : false;
      if (this.FullScreenState) {
        // 全屏
        let de = this.$refs.quanping;
        if (de.requestFullScreen) {
          // W3C
          de.requestFullscreen();
        } else if (de.mozRequestFullScreen) {
          // FireFox
          de.mozRequestFullScreen();
        } else if (de.webkitRequestFullScreen) {
          // Chrome等
          de.webkitRequestFullScreen();
        } else if (de.msRequestFullscreen) {
          // IE11
          de.msRequestFullscreen();
        }
      } else {
        // 退出全屏
        let de = document;
        if (de.exitFullscreen) {
          de.exitFullscreen();
        } else if (de.mozCancelFullScreen) {
          de.mozCancelFullscreen();
        } else if (de.webkitCancelFullScreen) {
          de.webkitCancelFullscreen();
        }
      }
    },
    // 点击查看视频
    onClickVideo(url) {
      this.$refs.videoDialogRef.init(url);
    },
    tabsIndexChange(i) {
      this.businessLeadIndex = i;
    },
    goToParkDetail(uuid) {
      //this.$router.push({ name: "allPark", params: { uuid: uuid } });
      let routeData = this.$router.resolve({
        name: "centerDetails",
        params: { uuid: uuid }
      });
      window.open(routeData.href, "_blank");
    },
    goToParkVr(items) {
      if (items.vrUrl) {
        let routeData = this.$router.resolve({
          name: "VeiwsUrl",
          query: {
            url: items.vrUrl
          }
        });
        window.open(routeData.href, "_blank");
      } else if (items.vrList.length > 0) {
        let routeData = this.$router.resolve({
          name: "veiws",
          params: { uuid: items.uuid }
        });
        window.open(routeData.href, "_blank");
      }
    },
    linkDownload(url) {},
    //获取banner图
    getIndexBanner() {
      operationSystem({
        type: "HOME",
        survival: "ENABLE"
      })
        .then(res => {
          if (res.list.length !== 0) {
            this.bannerList = res.list;
            this.imgLoad();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 主要业务
    getIndexVocationalWork() {
      getBannerList({
        groupCode: "MAIN_SERVICE"
      })
        .then(res => {
          this.mainTabs = res;
          /*this.mainMess.title = res[this.mainTabsIn].name;
                        this.mainMess.messages = res[this.mainTabsIn].remarks;
                        this.mainMess.value = res[this.mainTabsIn].value;*/
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 主要业务tabs点击切换
    getMainTabs(i) {
      this.mainTabsIn = i;
      /*this.mainMess.title = this.mainTabs[i].name;
                this.mainMess.messages = this.mainTabs[i].remarks;
                this.mainMess.value = this.mainTabs[i].value;*/
    },

    getMainTabDetail() {
      console.log(this.mainTabs[this.mainTabsIn]);
      let routeData = this.$router.resolve({
        name: this.mainTabs[this.mainTabsIn].linkUrl
      });
      window.open(routeData.href, "_blank");
    },

    async getParkAddrByName() {
      //    getParkAddrList({ param: this.inputMapParam })
      //      .then((response) => {
      // console.log(response)
      //        this.mapdata = response;
      //  console.log(this.settledInfo,222)

      //        this.initEcharts();
      //      })
      //      .catch(function (error) {
      //        console.log(error);
      //      });
      await getPrintEnterPriseList({ name: this.inputMapParam })
        .then(res => {
          // console.log(res)
          this.settledInfo = res;
        })
        .catch(function(error) {
          console.log(error);
        });
      this.getSettledInfo();
      this.initEcharts();
    },
    getClearMap() {
      //this.getParkAddrByName();
      this.getProviderSettledInfo();
    },
    queryNewText() {
      queryNewText({
        ignoreType: 1,
        ignoreOrigin: "ASSOCIATION",
        status: "PUBLISH",
        pageSize: 10
      })
        .then(response => {
          this.newList = response.data.slice(0, 5);
          this.newTopList = response.data.slice(5, 9);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 新闻资讯切换
    handleClick(tab, event) {
      // 新闻资讯查询
      if (tab.index == 0) {
        queryNewText({
          ignoreType: 1,
          ignoreOrigin: "ASSOCIATION",
          status: "PUBLISH",
          pageSize: 10
        })
          .then(response => {
            this.newList = response.data.slice(0, 5);
            this.newTopList = response.data.slice(5, 9);
          })
          .catch(function(error) {
            console.log(error);
          });
      } else if (tab.index == 1) {
        // 政策查询
        queryNewText({
          programUuid: "e7e94326-8426-4dec-b0c9-bebca13c3ccf",
          ignoreOrigin: "ASSOCIATION",
          status: "PUBLISH",
          pageSize: 10
        })
          .then(response => {
            this.newList = response.data.slice(0, 5);
            this.newTopList = response.data.slice(5, 9);
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },

    // 解决方案
    getsolutionListApi() {
      getIndexSolutionData()
        .then(res => {
          // console.log(111, res);
          this.solutionList = res;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 赋能案例
    getgetSolutionProList() {
      getSolutionList({
        current: 1,
        pageSize: 10,
        type: "CASE",
        status: "RELEASE"
      }).then(res => {
        this.solutionListQuery = res.data;
      });
    },
    setBackground(url, e) {
      e.currentTarget.style.backgroundImage = "url(" + url + ")";
    },

    goToDetail(uuid) {
      //this.$router.push({ name: "allPark", params: { uuid: uuid } });
      /*let routeData = this.$router.resolve({
        name: "allPark",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");*/
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: { enterPriseId: uuid }
      });
      window.open(routeData.href, "_blank");
    },
    saveFollow(item) {
      // 如果为当前登录用户的服务则不允许收藏
      // 获取当前用户信息
      if (this.isLogin) {
        if (item.userUuid == this.userMessages.uuid) {
          this.$message.error("无法关注自己的店铺");
          return false;
        }
        // 收藏服务
        let params = {
          enterPriseUuid: item.uuid
        };
        saveFollow(params).then(res => {
          if (res.success) {
            item.follow = !item.follow;
            this.$message.success("关注成功!");
            item.followUuid = res.data.uuid;
          }
        });
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！"
        });
        this.$router.push("/login");
      }
    },
    removeFollow(item) {
      // 收藏服务
      let params = {
        uuid: item.followUuid
      };
      removeFollow(params).then(res => {
        if (res.success) {
          item.follow = !item.follow;
          this.$message.success("取消成功!");
          item.followUuid = "";
        }
      });
    },
    getSoluBox() {
      //this.$router.push("/solution");
      let routeData = this.$router.resolve({
        name: "/solution"
      });
      window.open(routeData.href, "_blank");
    },

    getNewsItemDetail(uuid) {
      let routeData = this.$router.resolve({
        name: "newDetails",
        params: { uuid: uuid }
      });
      window.open(routeData.href, "_blank");
    },

    /*    getNewsDetails() {
              this.$router.push("/newDetails");
            },
            getNewsDetails2() {
              this.$router.push("/newDetails");
            },
            getNewsDetails3() {
              this.$router.push("/newDetails");
            },*/

    mapDivClick(e) {
      // console.log(e.offsetX, e.offsetY);
      // this.mapPopY = e.offsetX + "px";
      // this.mapPopX = e.offsetY + "px";
      // 计算
      let comTop = 500 - 130;
      let comBottom = this.$refs.ChinaMap.offsetWidth - 610;
      // 计算高度是否超过盒子高度
      if (comTop < e.offsetY) {
        this.mapPopX = comTop + "px";
      } else {
        this.mapPopX = e.offsetY + "px";
      }
      // 计算宽度是否超过盒子宽度

      if (comBottom < e.offsetX) {
        this.mapPopY = comBottom + "px";
        // console.log(444, this.mapPopY);
      } else {
        this.mapPopY = e.offsetX + "px";
      }
    },
    // 页面分辨率高度
    getBodyHeight() {
      sessionStorage.setItem(
        "documenHeight",
        window.innerHeight + "px" ||
          document.documentElement.clientHeight + "px" ||
          document.body.clientHeight + "px"
      );
      sessionStorage.getItem("documenHeight");
      this.documenHeight = sessionStorage.getItem("documenHeight") || "";
    },
    // 页面滚动
    menu() {
      if (this.$isMobile()) {
        //这里是移动端
        this.conShow = true;
        this.mainShow = true;
        this.soluShow = true;
        this.parkShow = true;
        this.parkShows = true;
        this.packFlexShow = true;
        this.newCenterShow = true;
        this.newCenterShow2 = true;
      } else {
        //这里是pc端
        this.scroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        // console.log(this.sroll);
        if (this.scroll > 200) {
          this.newCenterShow = true;
          this.newCenterShow2 = true;
        }
        if (this.scroll > 500) {
          this.conShow = true;
        }
        if (this.scroll > 1000) {
          this.mainShow = true;
        }
        if (this.scroll > 2300) {
          this.soluShow = true;
        }
        if (this.scroll > 2700) {
          this.parkShow = true;
        }
        if (this.scroll > 2900) {
          this.parkShows = true;
        }
        if (this.scroll > 3900) {
          this.packFlexShow = true;
        }
      }
    },
    circle_box_li_click(index) {
      let active = JSON.parse(JSON.stringify(this.core[index])); // 点击的
      // 当前中间的换到点击的位置展示
      this.$set(this.core, index, this.core[2]);
      // 点击的换到中间位置
      this.$set(this.core, 2, active);
    },

    getContentList(i) {
      this.contentTbas = i;
      this.contentMess.title = this.contentList[i].name;
      this.contentMess.messages = this.contentList[i].remarks;
    },

    getParkEnterpriseList() {
      // getParkEnterpriseList({ isKeyEnterprise: true })
      getParkEnterpriseList({ current: 1, pageSize: 20000 })
        .then(res => {
          // console.log("重点企业", res);
          res.data.forEach(item => {
            item.isShowPop = false;
          });
          this.parkList = res.data;
          this.$refs.mapRef.getMap(this.parkList);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 园区生态
    getParkInformationList: function() {
      getIndexParkList({
        current: 1,
        pageSize: 6
      })
        .then(res => {
          this.parkInformationList = res;
          this.getParkEnterpriseList();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getParkImg(i) {
      this.parkIndex = i;
      // this.getParkEnterpriseList(this.parkInformationList[i].uuid);
    },
    // 鼠标移入事件
    getMessagesAll() {
      this.messageAll = true;
    },
    // 鼠标移除事件
    getMessagesAllNo() {
      this.messageAll = false;
    },
    // 鼠标移入事件
    getEnterpriseAll(item, index) {
      // console.log("鼠标移入事件");
      item.isShowPop = true;
      // this.enterpriseAll = true;
      // this.enterpriseAllIndex = i;
    },
    // 鼠标移除事件
    getEnterpriseNo(item) {
      // console.log("鼠标移除事件");
      item.isShowPop = false;
    },

    //开发js   尤其要注意执行顺序和时间，异步和同步
    getMapData() {
      getParkAddrList()
        .then(response => {
          this.mapdata = response;
          this.initEcharts();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    dealWithData() {
      let newStr = JSON.parse(JSON.stringify(this.mapdata));
      // console.log(newStr)
      newStr.forEach(item => {
        item.name1 = item.name;
        item.name = "";
      });
      let data = newStr;
      return data;
    },
    getSettledInfo() {
      // console.log(this.settledInfo)
      let dataInfo = [];
      this.settledInfo.forEach(item => {
        let info = {};
        info.follow = item.follow;
        info.followUuid = item.followUuid;
        info.userUuid = item.userUuid;
        info.name1 = item.name;
        info.details = item.detailAddress;
        info.imageURL = item.storeHeader;
        info.content = item.content
          .replace(
            /<\s*\/?\s*[a-zA-z_]([^>]*?["][^"]*["])*[^>"]*>|&nbsp;|\s|[\r\n]*/g,
            ""
          )
          .replace("<br>", "")
          .replace("&gt;", ">")
          .replace("&lt;", "<")
          .replace("&amp;", "&");
        info.name = "";
        info.uuid = item.enterPriseId;
        info.materialCount = item.materialCount;
        info.goodsCount = item.goodsCount;
        info.serviceCount = item.serviceCount;
        info.orderCount = item.orderCount;
        info.province = item.province;
        info.city = item.city;
        info.value = [Number(item.lng), Number(item.lat)];
        dataInfo.push(info);
      });
      let data = dataInfo;
      return data;
    },
    async getProviderSettledInfo() {
      await getPrintEnterPriseList({ name: this.inputMapParam }).then(res => {
        res.forEach(item => {
          // 用户id
          findShopSettledInfo({ enterPriseId: item.enterPriseId }).then(res => {
            if (res.success) {
              if (res && res.data) {
                item.userUuid = res.data.userUuid;
              }
            }
          });
        });
        this.settledInfo = res;
        // console.log(res,111)
        this.initEcharts();
      });
    },
    getSolutionDetail(uuid) {
      //this.$router.push({ name: "caseDetails", params: { uuid: uuid } });
      let routeData = this.$router.resolve({
        name: "caseDetails",
        params: { uuid: uuid }
      });
      window.open(routeData.href, "_blank");
    },
    // 地图
    initEcharts() {},
    getNewsMore() {
      //this.$router.push("/news");
      let routeData = this.$router.resolve({
        name: "news"
      });
      window.open(routeData.href, "_blank");
    },
    changeCity(e) {
      // console.log(e);
      console.log(this.city);
      getParkEnterpriseList({ addr: this.city, current: 1, pageSize: 20000 })
        .then(res => {
          // console.log("重点企业", res);
          res.data.forEach(item => {
            item.isShowPop = false;
          });
          this.parkList = res.data;
          this.$refs.mapRef.getMap(this.parkList);
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.bannder_s {
  /deep/.el-carousel__arrow {
    top: 40% !important;
  }
}

.banner_video {
  position: absolute;
  bottom: 14%;
  left: 50%;
  transform: translate(-50%, 0);
  background: transparent;
  color: #fff;
  &:hover {
    color: #099;
  }
}
/* 公用样式 */

/* 标题 */
.title {
  width: 1200px;
  height: 88px;
  margin: 0 auto;
  color: #009999;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 54px;
  margin-top: 60px;

  .title_left {
    text-align: center;
    margin-top: 30px;
    height: 88px;

    .titleBig {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, 0);
      font-size: 80px;
      font-family: ABCMarfa-Bold, ABCMarfa;
      font-weight: bold;
      color: rgb(136 136 136 / 10%);
    }

    .titleSmill {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -15%);
      font-size: 28px;
      font-weight: 600;
      color: #1d1d1d;
    }
  }
}

// 地图弹框样式
.maps {
  position: absolute;
  z-index: 100;
  background: rgba(255, 255, 255, 0.797);
  padding: 20px;
  border-radius: 10px;
  max-width: 450px;

  .mapImg {
    width: 100px;
    border-radius: 50%;
    margin-right: 20px;
    flex-shrink: 0;

    /deep/ .el-image {
      margin-left: 25%;
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }

    img {
      margin-left: 25%;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: inline-block;
    }

    .mapImgIcon {
      margin-top: 10px;
      font-size: 14px;
      text-align: center;
      display: flex;
      align-items: center;

      i {
        color: #009999;
        font-size: 18px;
        margin-right: 3px;
      }

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .mapMess {
    width: 70%;

    .mapMessT {
      cursor: pointer;
      font-size: 18px;
      font-weight: 500;
    }

    .mapMessText {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
    }

    .mapMessWork {
      font-size: 14px;
      margin: 8px 0;
      align-items: center;
      flex-wrap: wrap;

      .text {
        margin-right: 10px;
        margin-bottom: 5px;
      }

      p {
        margin-right: 10px;
        width: 28px;
      }

      span {
        color: #009999;
        font-weight: bold;
      }

      .gangMess {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: #666;
        // margin: 0 12px;
        margin-right: 5px;
      }
    }

    .mapMessBox {
      align-items: center;
      margin: 10px 0;

      .mapMessP {
      }

      i {
        width: 2px;
        height: 15px;
        background: #cccccc;
        margin: 0 10px;
        display: inline-block;
      }
    }

    .mapMessBut {
      margin-top: 20px;
      display: flex;

      button {
        border-radius: 3px;
        color: #009999;
        padding: 6px 12px;
        border: 1px solid #009999;
        background: #fff;
        margin-right: 15px;
        width: 130px;
        cursor: pointer;
      }

      button:nth-child(2) {
        border-radius: 3px;
        color: #fff;
        padding: 6px 12px;
        border: 1px solid #009999;
        background: #009999;
      }
    }
  }
}

.gray {
  color: #929292;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.blue {
  color: #009999;
}

.home {
  cursor: default;
  overflow-x: hidden;
}

.topVideo {
  width: 100%;
  height: 100%;
  position: relative;

  img {
    height: 100%;
    width: 100%;
    display: block;
  }

  .topVideo_box {
    position: absolute;
    top: 30%;
    right: 15%;
    color: #fff;
    text-align: right;
    line-height: 45px;

    p {
      font-size: 24px;
    }

    button {
      background: #009999;
      border-radius: 5px;
      color: #fff;
      border: none;
      padding: 7px 15px;
      margin-top: 30px;
    }
  }
}

/* 平台是核心 */
.content {
  text-align: center;

  .content_top {
    width: 800px;
    margin: 0 auto;
    justify-content: space-between;

    .content_top_box {
      width: 110px;
      height: 110px;
      background: #ebebeb;
      border-radius: 50%;
      border: 1px solid #d1d1d1;
      color: #bababa;
      position: relative;
    }

    .content_top_box1 {
      width: 120px;
      height: 120px;
      background: #c9e1f8;
      border-radius: 50%;
      border: 1px solid #009999;
      color: #009999;
      position: relative;
    }

    .contetn_flex {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .content_box_name {
        font-size: 14px;
        margin-top: 7px;
      }
    }

    .content_box_img {
      height: 40px;

      img {
        height: 100%;
      }
    }
  }

  .content_title {
    margin: 24px 0;
  }

  .content_content {
    width: 476px;
    margin: 0 auto;
    font-size: 14px;
    color: #9c9c9c;
    line-height: 25px;
    margin-bottom: 60px;
  }

  .content_bottom {
    width: 90px;
    justify-content: space-between;
    margin: 0 auto;

    i {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #bababa;
    }

    .icon {
      background: #009999;
    }
  }
}

// 平台核心的动画效果
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
    /*初始状态 透明度为0*/
    transform: translateY(-50%);
  }

  50% {
    opacity: 0.5;
    /*中间状态 透明度为1*/
    transform: translateY(-25%);
  }

  100% {
    opacity: 1;
    /*结尾状态 透明度为0*/
    transform: translateY(0);
  }
}

.content_top1 {
  animation: fadeIn 1s linear 1;
  // animation: fadeIn 3s ease infinite 4s;
  overflow: hidden;
  transform: translateY(0);
  width: 800px;
  margin: 0 auto;
}

/* 新闻中心 */
.new_center {
  margin: 60px 0 0;
  background: #fff;

  .new_center_more {
    margin: 0 auto;
    width: 1200px;
    text-align: center;
    font-size: 13px;
    // color: #606060;
    color: #000;
    margin-bottom: 30px;
    cursor: pointer;
  }

  .new_center_more:hover {
    color: #009999;
  }

  .new_center_top {
    margin: 0 auto;
    width: 1200px;
    margin-bottom: 30px;

    // justify-content: center;
    .new_center_top_left {
      flex-shrink: 0;
      cursor: pointer;
      width: 540px;
      margin-right: 40px;
      background-color: #666;
      border-radius: 10px;

      .new_left_img {
        width: 470px;
        flex-shrink: 0;
        // height: 300px;
        background: #efefef;

        img {
          height: 100%;
          width: 100%;
          display: block;
        }
      }

      /deep/.el-carousel__indicators--horizontal {
        bottom: 16px;
        left: 84%;
        transform: translateX(0);
      }

      /deep/.el-carousel__button {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #009999;
      }

      /deep/.el-carousel__indicator.is-active button {
        width: 16px !important;
        border-radius: 6px !important;
      }

      .new_left_title {
        background-image: url("../assets/bannerbottom.png");
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        height: 60px;
        width: 100%;
        color: #fff;
        line-height: 60px;
        padding-left: 40px;
        font-size: 18px;
        border-radius: 0 0 8px 10px;
        box-sizing: border-box;
        span {
          display: inline-block;
          width: 76%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .new_right {
        position: absolute;
        bottom: 0;
        width: 705px;
        height: 60px;
        background: rgba(0, 0, 0, 0.6);
      }
    }

    .new_center_top_left:hover {
      .new_left_title {
        color: #009999;
      }
    }

    .new_center_top_right {
      .new_right_box {
        align-items: flex-start;
        cursor: pointer;

        .new_right_content {
          padding: 0 18px;
          display: flex;
          align-items: flex-start;
          margin-bottom: 30px;
          height: 45px;
          box-sizing: border-box;

          .new_rightTime {
            text-align: center;
            padding-right: 26px;
            margin-right: 26px;
            border-right: 1px solid #cecece;

            .new_right_time1 {
              font-size: 28px;
              font-family: BigruixianBlackGBV10;
              color: #009999;
            }

            .new_right_time {
              font-size: 12px;
              color: #909090;
              display: inline-block;
              margin: 0;
            }
          }

          .new_right_title {
            color: #000;
            font-weight: normal;
            font-size: 16px;
          }
        }
      }

      .new_right_box:hover {
        .new_right_title {
          color: #009999;
        }
      }
    }
  }

  .new_center_bottom {
    margin: 50px auto 0;
    width: 1200px;
    flex-wrap: wrap;
    justify-content: space-between;

    .new_bottom {
      cursor: pointer;
      padding-bottom: 25px;
      width: 270px;
      margin-bottom: 25px;

      span {
        font-size: 12px;
        margin-top: 15px;
      }

      p {
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 16px;
        line-height: 1.6;
        color: #808080;
        cursor: pointer;
        min-height: 50px;
      }
    }

    .new_bottom:hover {
      p {
        color: #009999;
      }
    }

    .new_bottom_empty {
      margin: 0;
      width: 270px;
      height: 0px;
      visibility: hidden;
    }

    .new_bottom:nth-child(-n + 4) {
      border-bottom: 1px solid #ececec;
    }
  }
}

@keyframes new_center_fadeIn {
  0% {
    opacity: 0;
    transform: translateX(-50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes new_center_fadeIn_r {
  0% {
    opacity: 0;
    transform: translateX(50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes new_center_fadeIn_b {
  0% {
    opacity: 0;
    transform: translateY(50%);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.new_center_top_left {
  animation: new_center_fadeIn 1s linear 1;
}

.new_center_top_right {
  animation: new_center_fadeIn_r 1s linear 1;
}

.new_center_bottom {
  animation: new_center_fadeIn_b 1s linear 1;
}
.coding {
  height: 740px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .title {
    margin-top: 60px;
    margin-bottom: 30px;
  }
}

.proddDigitization {
  overflow: hidden;
}

.m-60px-0-0 {
  margin: 66px 0 0px;
}

.hidden {
  overflow: hidden;
}

/* 园区生态 */
.park {
  margin: 66px 0 0px;

  .h-708 {
    height: 708px;
    background: #a2845e26;
  }

  .park_box {
    // background: #efefef;
    // height: 600px;
    position: relative;

    .park_box_img {
      width: 100%;

      img {
        height: 551px;
        width: 100%;
        display: block;
      }
    }

    .messageAll {
      position: absolute;
      top: 42%;
      left: 42%;
      width: 510px;
      background: rgba(0, 0, 0, 0.194);
      padding: 15px;
      color: #fff;
      line-height: 27px;
    }

    .park_background {
      margin: 0 auto;
      width: 600px;
      height: 420px;
      overflow: auto;
      // padding-top: 38px;
      position: absolute;
      top: 10%;
      bottom: 0;
      right: 254px;

      .bnt_box {
        margin-top: 58px;
        align-items: center;
        position: absolute;
        bottom: 58px;

        .flex {
          align-items: center;
          justify-content: center;

          img {
            width: 24px;
            height: 15px;
            margin-right: 5px;
          }
        }
      }

      .park_box_mess {
        background: rgb(0 0 0 / 40%);
        padding: 35px;
        height: 83%;
        position: relative;

        // height: 90%;
        .park_box_messtitle {
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 33px;
        }

        .park_box_messtext {
          margin-top: 20px;
          font-size: 16px;
          min-height: 110px;
          display: -webkit-box;
          overflow: hidden;
          white-space: normal !important;
          text-overflow: ellipsis;
          word-wrap: break-word;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
        }

        button {
          border: none;
          color: #009999;
          background: #fff;
          height: 24px;
          width: 60px;
          border-radius: 4px;
          // margin-top: 15px;
          font-size: 14px;
          cursor: pointer;
          margin-right: 10px;
        }
      }
    }

    .park_imglist {
      margin: 0 auto;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: 12px;

      .park_img2 {
        width: 190px;
        height: 0;
      }

      .park_img {
        // padding: 5px;
        width: 200px;
        // &:hover {
        //   box-shadow: 0 0 10px 4px #95baba78;
        //   .title_box{
        //     background: #099;
        //     color: #fff;
        //   }

        // }
        .title_box {
          width: 100%;
          height: 30px;
          background: #fff;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #6e6e6e;
          line-height: 17px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        // background: #ffffff3d;
        overflow: hidden;
        cursor: pointer;
        position: relative;
        margin-left: 14px;

        img {
          height: 100px;
          width: 100%;
          display: block;
        }

        .parkFuimg {
          background: #262626aa;
          width: 100%;
          height: 100px;
          position: absolute;
          top: 0;
        }
      }

      .park_img:first-child {
        margin-left: 0;
      }

      .park_active {
        width: 200px;
        // background: #ffffff76;
        // box-shadow: 0px 0px 14px 2px #ffffffc9;
        overflow: hidden;
        box-shadow: 0 0 10px 4px #cad1d178;
        img {
          height: 100px;
          width: 100%;
        }

        .parkFuimg {
          background: transparent;
        }
      }
    }
  }

  .park_bottom {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    min-height: 822px;
    position: relative;
    .iconStyle {
      position: absolute;
      right: 8px;
      top: 10px;
      font-size: 24px;
      cursor: pointer;
    }
    .title {
      margin-bottom: 34px;
    }

    .park_bottom_content {
      width: 100%;
      height: 100%;
      // padding-top: 60px;

      .park_bottom_title {
        font-size: 24px;

        i {
          display: inline-block;
          width: 50px;
          height: 5px;
          background: #009999;
        }
      }

      .pack_flex {
        width: 100%;
        height: 100%;
        justify-content: space-between;
        flex-wrap: wrap;
        background-size: 100% 100%;
        // padding-bottom: 10px;
        position: relative;
        .park_bottom_list2 {
          width: 270px;
          height: 0;
        }
        /deep/.mapCont {
          z-index: 99;
        }
        .pack_img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 1493px;
        }

        .park_bottom_list {
          position: relative;
          width: 270px;

          .enterpriseAll {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 400px;
            font-size: 14px;
            background: rgba(0, 0, 0, 0.557);
            padding: 15px;
            color: #fff;
            z-index: 99;
          }

          .park_bottom_img {
            width: 270px;
            height: 150px;
            background: #fff;
            overflow: hidden;

            img {
              height: 100%;
              width: 100%;
              transition: all 1s;
            }
          }

          .park_bottom_text {
            cursor: pointer;
            background: #fff;
            padding: 15px 25px 30px;
            line-height: 20px;
            height: 124px;
            cursor: pointer;

            div {
              font-size: 14px;
              text-align: center;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            p {
              font-size: 13px;
              margin-top: 14px;
            }
          }
        }

        .park_bottom_list:hover {
          img {
            transform: scale(1.2);
          }

          .park_bottom_text {
            div {
              color: #009999;
            }
          }
        }
      }
    }
  }
}

@keyframes park_fadeIn {
  0% {
    opacity: 0;
    transform: translateX(-50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.park_box_mess {
  animation: park_fadeIn 1s linear 1;
}

@keyframes park2_fadeIn {
  0% {
    opacity: 0;
    transform: translateX(50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.park_imglist {
  // animation: park2_fadeIn 1s linear 1;
}

// @keyframes parkBotton_fadeIn {
//   0% {
//     opacity: 0;
//     transform: translateY(-20%);
//   }

//   100% {
//     opacity: 1;
//     transform: translateY(0);
//   }
// }

.pack_flex {
  animation: parkBotton_fadeIn 1s linear 1;
}

/* 解决方案 */
.solution {
  margin-top: 66px;

  .solution_box {
    border-top: 1px solid #efefef;
    justify-content: space-between;

    .solution_boxmess {
      // width: 1200px;
      margin: 0 auto;
      flex-wrap: wrap;

      .solution_box_mess {
        height: 229px;
        cursor: pointer;
        border-top: 1px solid #efefef;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        /* Firefox */
        -webkit-box-sizing: border-box;
        /* Safari */
        border-right: 1px solid #efefef;
        // background: hsla(0,0%,100%,0);
        // background: url("../assets/solutionHome.png") no-repeat right center;
        background: hsla(0, 0%, 100%, 0);
        background-size: 150% 229px;
        overflow: hidden;
        width: 50%;
        padding: 34px 0 42px 0;
        justify-content: flex-end;

        .solution_box_text {
          width: 600px;

          h5 {
            font-size: 16px;
            font-weight: normal;
            color: #009999;
            margin-bottom: 10px;
          }

          h4 {
            margin: 0 0 15px 0;
            font-size: 18px;
            font-weight: normal;
            width: 470px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          p {
            font-size: 14px;
            width: 470px;
          }
        }
      }

      .solution_box_mess:hover {
        background: no-repeat center center;
        background-size: 120% 229px;
        -webkit-transition: background-size 0.3s linear;
        transition: background-size 0.3s linear;
      }

      .solution_box_mess:nth-child(2n + 2) {
        border-right: none;
        justify-content: flex-start;
        padding-left: 32px;
        width: 50%;
      }
    }
  }

  .solution_box:nth-last-child(1) {
    border-bottom: 1px solid #efefef;
  }
}

@keyframes solu_fadeIn {
  0% {
    opacity: 0;
    transform: translateY(50%);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.solution_box {
  animation: solu_fadeIn 1s linear 1;
}

/* 主要业务 */
.main {
  margin-top: 60px;

  .main_tabs {
    align-items: center;
    justify-content: center;
    font-size: 16px;
    width: 970px;
    margin: 0 auto 10px auto;

    p {
      width: 170px;
      padding-bottom: 15px;
      text-align: center;
      cursor: pointer;
      border-bottom: 4px solid #fff;
    }

    .main_active {
      border-bottom: 4px solid #009999;
      color: #009999;
    }
  }

  .main_mess {
    // align-items: center;
    .main_mess_img {
      text-align: center;
      width: 50%;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .main_mess_content {
      // background: linear-gradient(-45deg, #219afd, #2eb6fd);
      // background: #2eb6fd;
      width: 50%;
      color: #fff;
      font-weight: 300;
      position: relative;

      .main_mess_content2 {
        width: 100%;

        img {
          width: 100%;
          display: block;
        }
      }

      .main_mess_box {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        left: 85px;
        width: 500px;

        .main_con_title {
          font-size: 26px;
        }

        .main_con_text {
          font-size: 18px;
          margin: 30px 0 50px;
        }

        .main_con_more {
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
}

.mapPosition {
  position: relative;
  background: #9fd7fc;

  .mapInput {
    position: absolute;
    z-index: 100;
    top: 10%;
    left: 12%;
    height: 33px;

    // align-items: center;
    /deep/ .el-input {
      height: 33px;
      width: 221px;
    }

    /deep/ .el-input__inner {
      height: 33px;
      border-radius: 0;
    }

    /deep/ .el-input__suffix {
      top: -3px;
    }

    input {
      width: 221px;
      height: 100%;
      background: #fff;
      border: none;
      padding: 0px 14px;
    }

    i {
      display: inline-block;
      height: 100%;
      width: 40px;
      line-height: 33px;
      text-align: center;
      background: #009999;
      color: #fff;
      font-size: 18px;
    }
  }
}

@keyframes new_fadeIn {
  0% {
    opacity: 0;
    transform: translateX(-50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes new_fadeIn_r {
  0% {
    opacity: 0;
    transform: translateX(50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.main_mess_img {
  animation: new_fadeIn 1s linear 1;
}

.main_mess_content {
  animation: new_fadeIn_r 1s linear 1;
}

// 地图弹框样式
.map {
  align-items: center;
  position: absolute;
  z-index: 100;
  background: rgba(255, 255, 255, 0.797);
  padding: 20px;
  border-radius: 10px;
  width: 400px;

  .mapImg {
    flex-shrink: 0;
    width: 90px;
    height: 90px;
    background: #efefef;
    border-radius: 50%;
    margin-right: 10px;

    /deep/ .el-image {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }

    img {
      // border-radius: 50%;
      display: inline-block;
    }
  }

  .mapMess {
    .mapMessT {
      font-size: 18px;
      font-weight: 500;
    }

    .mapMessBox {
      align-items: center;
      margin: 10px 0;

      .mapMessP {
      }

      i {
        width: 2px;
        height: 15px;
        background: #cccccc;
        margin: 0 10px;
        display: inline-block;
      }
    }

    .mapMessBut {
      margin-top: 20px;
      cursor: pointer;
      display: flex;
      align-items: center;

      button {
        border-radius: 3px;
        color: #009999;
        padding: 6px 12px;
        border: 1px solid #009999;
        background: #fff;
        margin-right: 15px;
        width: 150px;
      }

      // button:nth-child(2) {
      //   border-radius: 3px;
      //   color: #fff;
      //   padding: 6px 12px;
      //   border: 1px solid #009999;
      //   background: #009999;
      // }
    }
  }
}

.tpis {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  cursor: pointer;
}

.animated {
  animation-duration: 3s;
  /* 定义3秒的动画时间 */
}
.my-tabs {
  /deep/.el-tabs__item {
    font-size: 26px;
    line-height: 19px;
    font-weight: 600;
  }

  /deep/.el-tabs__nav-wrap::after {
    background-color: white;
  }
}

.my-select {
  /deep/ .el-input__icon {
    line-height: 30px;
  }
  /deep/.el-input__inner {
    height: 30px;
    line-height: 30px;
  }
  /deep/.el-select {
    width: 150px;
    margin-top: 20px;
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue